import axios from 'axios';
import { useAuthStore } from '../hooks/useAuthStore';

const BASE_URL = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
  },
  timeout: 15000,
});

api.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuthStore.getState();
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    console.log(error.response)

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 

      try {
        const { refreshToken, logout } = useAuthStore.getState();


        if (!refreshToken) {
          logout();
        }

        const response = await axios.post(
        `${BASE_URL}/refresh`,
        refreshToken, 
        {
            headers: {
            'Content-Type': 'text/plain', 
            },
        }
        );
        
        const newAccessToken =  response.data;
        
        useAuthStore.setState({ accessToken: newAccessToken });

        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        return api(originalRequest);

      } catch (refreshError) {
        console.error('[ApiService] Session expirée, déconnexion forcée.');
        
        const { logout } = useAuthStore.getState();
        logout(); 
        
        return Promise.reject(refreshError);
      }
    }

    if (error.response) {
      const { status } = error.response;
      if (status === 403) console.warn('[ApiService] 403 — accès refusé');
      if (status >= 500) console.error('[ApiService] Erreur serveur:', error.response.data);
    } else if (error.code === 'ECONNABORTED') {
      console.error('[ApiService] Timeout — le serveur ne répond pas');
    } else {
      console.error('[ApiService] Erreur réseau:', error.message);
    }

    return Promise.reject(error);
  }
);

export default api;